import { dateFormatter } from "src/utils/helpers/DateAndTimeHelpers";

type DcaStrategySummaryFrequency = "Day" | "Week" | "Month" | "Quarter";

// This function is used to calculate the date of the second order
export const calculateSecondOrderDate = (
  startDate: number,
  frequency: DcaStrategySummaryFrequency,
): string => {
  const date = new Date(startDate);

  switch (frequency) {
    case "Day":
      date.setDate(date.getDate() + 1);
      break;
    case "Week":
      date.setDate(date.getDate() + 7);
      break;
    case "Month":
      date.setMonth(date.getMonth() + 1);
      break;
    case "Quarter":
      date.setMonth(date.getMonth() + 3);
      break;
    default:
      throw new Error("Invalid frequency");
  }

  return dateFormatter(date.getTime());
};

export const formatStatus = (status: string) => {
  switch (status) {
    case "EXECUTED":
      return "Completed";
    case "FAILED":
      return "Failed";
    default:
      return "Pending";
  }
};
